import React from 'react';
import { Link } from 'react-router-dom';

function MenuItem({ path, icon, label, style }) {
    return (
        <Link
            to={path}
            className={`select-none flex items-center gap-3 text-nowrap text-[14px] font-semibold leading-5 text-[#D1D5DB] p-[8px_12px_8px_8px] ${style}`}
        >
            <div className="w-6 h-6 flex items-center justify-center">
                <img src={icon} alt={label} />
            </div>

            <span>{label}</span>
        </Link>
    );
}

export default MenuItem;
